import {defineStore} from 'pinia'

export const useEventsStore = defineStore('events', {
    state: () => ({
        expandCollapseSessionDescriptionState: '',
        hasDisplayedConflictNag: false,
        scheduleRoute: null,
    }),
})